var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',_vm._g(_vm._b({staticClass:"v-tabs--monpatrol flat",on:{"change":_vm.handleChange}},'v-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._t("items")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }